import React from 'react';
import withMiddleFeatures from '@@viewCommonHoc/withMiddleFeatures.jsx';
import SimulationDemographyForm from './SimulationDemographyForm.jsx';
import withGlobalData from '@@viewCommonHoc/withGlobalData.jsx';
import { compose } from 'ramda';
import useGetSimulationDemographyQuery from './hooks/useGetSimulationDemographyQuery.js';
import { Loading } from '@fasstech/middle-design-system';

const SimulationDemography = ({
  getMiddleText,
  getMiddleBoolean,
  getMiddleNumber,
  regimeObligatoire
}) => {
  const { getSimulationDemography, loading: isFetchingGetDemography } =
    useGetSimulationDemographyQuery();

  if (isFetchingGetDemography) return <Loading />;

  return (
    <SimulationDemographyForm
      getDemography={getSimulationDemography}
      getMiddleText={getMiddleText}
      getMiddleBoolean={getMiddleBoolean}
      getMiddleNumber={getMiddleNumber}
      regimeObligatoire={regimeObligatoire}
    />
  );
};

export default compose(withGlobalData, withMiddleFeatures)(SimulationDemography);
